var React = require('react');
var ReactRedux = require('react-redux');

var TextArea = require('../components/TextArea.jsx');
var actions = require('../_actions.js');
const deployment = require('../constants/deployment.js');
const moment = require('moment-timezone');

function getDates() {
	const date = new Date();
	const chckDates = [<option value="" key="unset">-</option>];
	const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	// Set date to yesterday as in the loop we immediately add one day (i.e. allow setting of "today" as the time)
	date.setDate(date.getDate() - 1);
	for (let i = 0; i < 30; i++) {
		date.setDate(date.getDate() + 1);
		const dmy = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();

		chckDates.push(<option key={i} value={dmy}>{dmy}</option>);
	}
	return chckDates;
}

function getHours() {
	let hr;
	const hrs = [<option value="" key="unset">-</option>];
	for (let i = 0; i <= 23; i++) {
		if (i < 10) {
			hr = "0" + i + ":00";
		} else {
			hr = i + ":00";
		}

		hrs.push(<option key={i} value={hr}>{hr}</option>);
	}
	return hrs;
}

function getWindows() {
	const windows_arr = [<option key="unset" value="">-</option>];
	for (let i = 1; i <= 3; i++) {
		if (i === 1) {
			windows_arr.push(
				<option key={i} value={i}>{i} hour</option>
			);
			continue;
		}
		windows_arr.push(
			<option key={i} value={i}>{i} hours</option>
		);
	}
	return windows_arr;
}

var summary = function (props) {
	let schedule = null;
	if (props.can_schedule) {
		let caret = 'up';
		let open = true;
		let select_text = 'Hide scheduling options';
		if (!props.schedule_open) {
			caret = 'down';
			open = false;
			select_text = 'Show scheduling options';
		}
		const stateClassName = open === true ? 'show' : 'hide';

		schedule = (
			<div>
				<header><h4 className="schedule_title">Scheduling</h4></header>
				<p>Optionally choose a time to run this deployment, times in this form are displayed
					in {props.server_timezone} time.</p>
				<p>
					<a href={"javascript:void(0);"} onClick={() => {
						props.toggleScheduleOpen(open);
					}}>{select_text} <i className={"fa fa-caret-" + caret}></i></a>
				</p>
				<span className={"schedule_form " + stateClassName}>
					<div className="form-group">
						<label htmlFor="deploy_date">Desired day</label>
						{props.validation_errors.deploy_date &&
						<p className="schedule-alert alert alert-error">{props.validation_errors.deploy_date}</p>
						}
						<select name="deploy_date" id="deploy_date"
										defaultValue={props.schedule_start ? props.schedule_start.format('D MMM YYYY') : ""}
										onChange={props.onDateChange}>
							{getDates()}
						</select>
					</div>
					<div className="form-group">
						<label htmlFor="deploy_time">Desired hour on that day</label>
						{props.validation_errors.deploy_time &&
						<p className="schedule-alert alert alert-error">{props.validation_errors.deploy_time}</p>
						}
						<select name="deploy_time" id="deploy_time"
										defaultValue={props.schedule_start ? props.schedule_start.format('HH:mm') : ""}
										onChange={props.onTimeChange}>
							{getHours()}
						</select>
					</div>
					<div className="form-group">
						<label htmlFor="deploy_window">Deployment window</label><br/>
						{props.validation_errors.deploy_window &&
						<p className="schedule-alert alert alert-error">{props.validation_errors.deploy_window}</p>
						}
						<select name="deploy_window" id="deploy_window"
										defaultValue={props.schedule_window ? props.schedule_window : ""} onChange={props.onWindowChange}>
							{getWindows()}
						</select>
						<small>
							<i className="fa fa-info-circle"></i> As there is a limited amount of queue workers it is not guaranteed that the deployment
							will start precisely on the selected hour. The deployment window indicates how much of a delay is acceptable before invalidating the scheduled deployment.
						</small>
					</div>
				</span>
			</div>
		);
	}

	return (
		<div>
			<div className="form-group">
				<label htmlFor="deploy_summary">Description</label>
				<TextArea
					id="deploy_summary"
					value={props.summary_of_changes}
					onChange={props.onSummaryChange}
					disabled={!props.can_edit}
				/>
			</div>
			{schedule}
		</div>
	);
};

const mapStateToProps = function (state) {
	let schedule_start = null;
	let schedule_window = null;

	if (state.plan.schedule_start) {
		schedule_start = moment.unix(state.plan.schedule_start);
	}
	if (state.plan.schedule_start && state.plan.schedule_end) {
		const diff = state.plan.schedule_end - state.plan.schedule_start;
		schedule_window = diff / 60 / 60;
	}

	return {
		summary_of_changes: state.plan.summary_of_changes,
		can_edit: deployment.canEdit(state),
		can_schedule: state.environment.can_schedule,
		schedule_start: schedule_start,
		schedule_window: schedule_window,
		validation_errors: state.deployment.schedule_errors,
		server_timezone: state.user.server_timezone,
		schedule_open: state.deployment.schedule_open,
	};
};

const mapDispatchToProps = function (dispatch) {
	return {
		onSummaryChange: function (evt) {
			dispatch(actions.setSummary(evt.target.value));
		},
		onDateChange: function (evt) {
			dispatch(actions.setDate(evt.target.value));
		},
		onTimeChange: function (evt) {
			dispatch(actions.setTime(evt.target.value));
		},
		onWindowChange: function (evt) {
			dispatch(actions.setWindow(evt.target.value));
		},
		toggleScheduleOpen: function (evt) {
			dispatch(actions.toggleScheduleOpen(evt));
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(summary);
